module.exports = __webpack_public_path__ + "img/signSuccess.34061a1c.png";